export default "__VITE_ASSET__dag29rXA__"